import React from 'react';
import JobOverview from './Content/JobOverview';
import AboutTheRole from './Content/AboutTheRole';
import JobDescription from './Content/JobDescription';
import PerksAndBenefits from './Content/PerksAndBenefits';
import PreferredVisaTypes from './Content/PreferredVisaTypes';
import ApplicationRequirements from './Content/ApplicationRequirements';
import BottomBanner from './Content/BottomBanner';
import DetailViewHeader from './DetailViewHeader';
import { DetailPromoBanner } from './Sidebar/DetailSidebar';

const DetailView = ({ isAdmin, job, optionMeta }) => {
  return (
    <div
      className={`flex flex-col p-0 w-full min-w-0 ${
        isAdmin ? 'tabletV:w-[868px]' : 'tabletV:w-[719px]'
      }`}
    >
      {isAdmin && (
        <DetailViewHeader job={job} optionMeta={optionMeta} variant='admin' />
      )}
      <JobOverview job={job} optionMeta={optionMeta} />
      <AboutTheRole job={job} />
      <JobDescription job={job} />
      <PerksAndBenefits job={job} />
      <ApplicationRequirements job={job} />
      <PreferredVisaTypes job={job} optionMeta={optionMeta} />
      {/* 관리자 미리보기에는 프로모션 배너를 넣지 않는다 */}
      {!isAdmin && (
        <div className='mb-10 tabletV:hidden'>
          <DetailPromoBanner />
        </div>
      )}
      <BottomBanner fullWidth={isAdmin} />
    </div>
  );
};

export default DetailView;
